import { Link } from 'react-router-dom'
import React from 'react'

export const LinkToPostItem = ({ _id, children, className }: any) => {
  return (
    <Link to={`/post/${encodeURIComponent(_id)}`} className={className}>
      {children}
    </Link>
  )
}
